import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
import $ from 'jquery';
const ITEM = '.HomepageCarousel-navItem';
const SLIDE = '.HomepageCarousel-slide';
export const init = async function() {
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Pagination,
        Lazy
    ]);
    // settings
    const settings = {
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        // Enable lazy loading
        lazy: {
            loadPrevNext: true
        },
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        spaceBetween: 20,
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 27
            }
        }
    };
    // init carousel
    let mySwiper = new Swiper('.js-homepage-carousel', settings);
    // hide all slides
    $(SLIDE).hide();
    $(SLIDE).removeClass('swiper-slide');
    // Function to update aria-selected and tabindex attributes
    const updateAttributes = ()=>{
        $(ITEM).each(function() {
            if ($(this).hasClass('active')) {
                $(this).attr('aria-selected', 'true');
            } else {
                $(this).attr('aria-selected', 'false');
            }
        });
    };
    // reinit carousel on category change
    $(ITEM).on('click', function() {
        mySwiper.destroy();
        $(ITEM).removeClass('active').attr('aria-selected', 'false');
        $(this).addClass('active').attr('aria-selected', 'true').attr('tabindex', '0');
        const collection = $(this).attr('collection-name');
        $(SLIDE).hide();
        $('.HomepageCarousel-slide[data-collection="' + collection + '"]').show();
        $('.HomepageCarousel-slide[data-collection="' + collection + '"]').addClass('swiper-slide');
        mySwiper = new Swiper('.js-homepage-carousel', settings);
        // Update attributes after the carousel has been re-initialized
        updateAttributes();
    });
    // trigger click on first category
    $(ITEM).first().trigger('click');
    //KEYBOARD USERS
    $(ITEM).on('keyup', function(e) {
        if (e.keyCode === 13) {
            mySwiper.destroy();
            $(ITEM).removeClass('active').attr('aria-selected', 'false');
            $(this).addClass('active').attr('aria-selected', 'true');
            const collection = $(this).attr('collection-name');
            $(SLIDE).hide();
            $('.HomepageCarousel-slide[data-collection="' + collection + '"]').show();
            $('.HomepageCarousel-slide[data-collection="' + collection + '"]').addClass('swiper-slide');
            mySwiper = new Swiper('.js-homepage-carousel', settings);
            // Update attributes after the carousel has been re-initialized
            updateAttributes();
        }
    });
};
